export default __webpack_public_path__ + "static/media/Artboard 38.1a2faf10.png";